import React from "react";
import { Layout, Providers } from "./src/ts/components/Layout";

import "@fontsource/anton/latin-400.css"; // 400.css includes a bunch more font faces (-ext, ...)
import "@fontsource/antonio/400.css";
import "@fontsource/antonio/700.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/700.css";

// Wraps every page in a component
export const wrapPageElement = ({
    element,
    props,
}: {
    element: React.ReactNode;
    props: any;
}) => {
    return <Layout {...props}>{element}</Layout>;
};

// Wraps every page in a component
export const wrapRootElement = ({
    element,
}: {
    element: React.ReactNode;
}) => {
    return <Providers>{element}</Providers>;
};
